import auth from './auth';

// 用户摄入
export function userHomePageView(data) {
    return auth({
        url: '/nutrients/ai/api/userHomePageView',
        method: 'post',
        data
    })
}

// 用户健康画像
export function getUserHealthyProfile(data) {
    return auth({
        url: '/nutrients/ai/api/getUserHealthyProfile',
        method: 'post',
        data
    })
}

// 保存用户健康画像
export function saveUserHealthyProfile(data) {
    return auth({
        url: '/nutrients/ai/api/saveUserHealthyProfile',
        method: 'post',
        data
    })
}

// 用户日数据分析
export function userDayIngestionCheck(data) {
    return auth({
        url: '/nutrients/ai/api/userDayIngestionCheck',
        method: 'post',
        data
    })
}

// 用户指定日期区间数据分析
export function countUserIngestion4DateRange(data) {
    return auth({
        url: '/nutrients/ai/api/countUserIngestion4DateRange',
        method: 'post',
        data
    })
}


// 民族枚举
export function nationalityEnum() {
    return auth({
        url: '/nutrients/api/nationalityEnum',
        method: 'post',
    })
}

// 用户标签
export function getAllCommonFlag() {
    return auth({
        url: '/nutrients/ai/api/getAllCommonFlag',
        method: 'post',
    })
}
